/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Registration } from '../models/Registration';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class RegistrationsService {

    /**
     * @param id
     * @param formId
     * @param divisionId
     * @returns Registration OK
     * @throws ApiError
     */
    public static list(
        id?: number,
        formId?: number,
        divisionId?: number,
    ): CancelablePromise<Array<Registration>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/registrations',
            query: {
                'id': id,
                'formId': formId,
                'divisionId': divisionId,
            },
        });
    }

}
